import React from "react";
import PublicShell from "../../components/PublicShell";
import { useInstitutional } from "../../lib/brand";
import usePageSeo from "../../lib/seo";

function PrivacyBody({ email }) {
  return (
    <>
      <p>
        Esta política descreve como a Azuhomes coleta, utiliza e armazena dados pessoais dos hóspedes e visitantes
        do site, em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018).
      </p>
      <h2 className="font-display text-2xl text-[#0AA89C] mt-8 mb-2">Dados coletados</h2>
      <p>
        Coletamos exclusivamente os dados necessários à execução das reservas: nome completo, endereço eletrônico,
        número de telefone, número de documento (quando aplicável), datas de estadia e dados de pagamento
        processados diretamente pela plataforma do Mercado Pago.
      </p>
      <h2 className="font-display text-2xl text-[#0AA89C] mt-8 mb-2">Finalidade</h2>
      <p>
        Os dados são utilizados para a formalização da reserva, para o envio de comunicações relativas à estadia
        e para o cumprimento de obrigações legais e fiscais. Não comercializamos, cedemos ou compartilhamos dados
        pessoais com terceiros para finalidades de marketing.
      </p>
      <h2 className="font-display text-2xl text-[#0AA89C] mt-8 mb-2">Direitos do titular</h2>
      <p>
        O titular pode, a qualquer momento, solicitar o acesso, a correção, a portabilidade ou a exclusão dos seus
        dados pessoais. Para tanto, basta encaminhar a solicitação para o endereço {email || "—"}.
      </p>
      <h2 className="font-display text-2xl text-[#0AA89C] mt-8 mb-2">Retenção</h2>
      <p>
        Os dados são mantidos pelo prazo necessário ao cumprimento das obrigações fiscais e regulatórias
        aplicáveis, sendo posteriormente descartados.
      </p>
      <p className="text-sm text-[#6B7280] mt-8">
        Esta política pode ser atualizada. A versão vigente estará sempre disponível nesta página.
      </p>
    </>
  );
}

function TermsBody({ jurisdictionCity, jurisdictionState }) {
  return (
    <>
      <p>
        O acesso ao site e a utilização dos serviços da Azuhomes implicam a aceitação integral destes termos.
      </p>
      <h2 className="font-display text-2xl text-[#0AA89C] mt-8 mb-2">Reservas</h2>
      <p>
        A reserva somente será considerada confirmada após a aprovação do respectivo pagamento pelo Mercado Pago
        e a validação interna da nossa equipe. Enquanto o pagamento estiver em processamento, as datas permanecem
        bloqueadas temporariamente, sem gerar obrigação de manutenção da tarifa.
      </p>
      <h2 className="font-display text-2xl text-[#0AA89C] mt-8 mb-2">Cancelamento</h2>
      <p>
        As regras de cancelamento aplicáveis a cada reserva são apresentadas antes da conclusão do pagamento e
        passam a integrar o contrato firmado entre as partes. Solicitações de cancelamento devem ser enviadas
        por escrito, preferencialmente pelos canais oficiais da Azuhomes.
      </p>
      <h2 className="font-display text-2xl text-[#0AA89C] mt-8 mb-2">Responsabilidades do hóspede</h2>
      <p>
        O hóspede é responsável pela conservação do imóvel durante o período da estadia. Danos causados por dolo
        ou culpa serão apurados e cobrados nos termos do contrato de hospedagem.
      </p>
      <h2 className="font-display text-2xl text-[#0AA89C] mt-8 mb-2">Foro</h2>
      <p>
        Fica eleito o foro da comarca de {jurisdictionCity || "—"}, Estado {jurisdictionState ? `de ${jurisdictionState}` : "—"}, para dirimir eventuais controvérsias
        decorrentes destes termos, com renúncia expressa a qualquer outro, por mais privilegiado que seja.
      </p>
      <p className="text-sm text-[#6B7280] mt-8">
        Estes termos podem ser atualizados. A versão vigente estará sempre disponível nesta página.
      </p>
    </>
  );
}

export default function Legal({ kind = "privacy" }) {
  const inst = useInstitutional();
  const isPrivacy = kind === "privacy";
  const email = inst?.email_institutional || inst?.email_reservations || "";
  const city = inst?.address?.city || "";
  const state = inst?.address?.state || "";
  usePageSeo({
    title: isPrivacy ? "Política de privacidade" : "Termos de uso",
    description: isPrivacy
      ? "Como a Azuhomes coleta, utiliza e armazena dados pessoais dos hóspedes."
      : "Termos e condições de uso da plataforma Azuhomes.",
    path: isPrivacy ? "/politica-privacidade" : "/termos",
    noindex: false,
  });
  return (
    <PublicShell>
      <section className="max-w-3xl mx-auto px-6 lg:px-10 py-24">
        <span className="text-[11px] uppercase tracking-[0.28em] text-[#066B63]">
          {isPrivacy ? "Política" : "Termos"}
        </span>
        <h1 className="font-display text-4xl md:text-5xl text-[#0AA89C] mt-3">
          {isPrivacy ? "Política de privacidade" : "Termos de uso"}
        </h1>
        <div className="mt-8 space-y-4 text-[#22302E] leading-relaxed">
          {isPrivacy ? <PrivacyBody email={email} /> : <TermsBody jurisdictionCity={city} jurisdictionState={state} />}
        </div>
      </section>
    </PublicShell>
  );
}
